import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import { SubmitLocationsPayload } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

interface UseSubmitReviewAnalysisLocationsMutationParams {
  onError?: () => void
  onSuccess?: () => void
}

export const useSubmitReviewAnalysisLocationsMutation = (
  campaignId: string,
  { onError, onSuccess }: UseSubmitReviewAnalysisLocationsMutationParams = {}
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: SubmitLocationsPayload) =>
      ReviewAnalysisApiService.submitLocations(campaignId, payload),
    onError: () => {
      onError?.()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_OVERVIEW, campaignId],
      })
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_CAMPAIGN, campaignId],
      })
      onSuccess?.()
    },
  })
}
